import { render, staticRenderFns } from "./GenericInformationComponent.vue?vue&type=template&id=4be896aa&"
import script from "./GenericInformationComponent.vue?vue&type=script&lang=ts&"
export * from "./GenericInformationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports